import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TmsService {

  constructor(
    private http: HttpClient
  ) { }

  /**
   * get TMS Error Log
   * @param params
   */
   getTMSErrorLog(bookingNo: string): Observable<any>{
    const url = `${environment.b2bApiUrl}/tms/tmsInErrorLog/${bookingNo}`;
    return this.http.get(url);
  }

  /**
   * Resend Tms
   * @param {*} tmsObj
   * @return {*}  {Observable<any>}
   * @memberof TmsService
   */
  reSendTms(tmsObj: any): Observable<any>{
    const url = `${environment.b2bApiUrl}/tms/tmsInErrorLog`;
    return this.http.post(url, tmsObj);
  }

}
